export default __webpack_public_path__ + "static/media/gournay4.2d8b93a0.jpg";